import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      fill="#026100"
      d="M8.754 16.5 3.53 11.275l1.307-1.306 3.918 3.919 8.41-8.41 1.307 1.305z"
    />
  </svg>
);
export default SvgCheck;
